import { render, staticRenderFns } from "./AddPositionDialog.vue?vue&type=template&id=fa67de9e"
import script from "./AddPositionDialog.vue?vue&type=script&lang=js"
export * from "./AddPositionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports